'use strict';
define([
    'angular',
    'modules/access/signin-zendesk/signin-zendesk.controller',
],function(angular, SigninZendeskController){
    var app = angular.module('access.signin-zendesk', []);
    app.controller('SigninZendeskController', SigninZendeskController);
    return app;
});
